module.exports = __webpack_public_path__ + "media/icons/paliwo@2x-ec698aab.png";